import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { generateGameUrl } from '../../../utils/urlUtils'; 

const RelatedGames = ({ games, title = "Related Games" }) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-semibold text-foreground">{title}</h3>
        <Button variant="ghost" size="sm" iconName="ArrowRight" iconPosition="right">
          View All
        </Button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {games.map((game) => (
          <Link
            key={game.id}
            to={generateGameUrl(game)}
            state={{ game }}
            className="group bg-card border border-border rounded-lg overflow-hidden hover:border-primary/50 transition-colors"
          >
            <div className="relative aspect-video overflow-hidden">
              <Image
                src={game.cover_image_url}
                alt={game.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
              />
              
              {/* Play Overlay */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-200 flex items-center justify-center">
                <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <Icon name="Play" size={20} color="white" />
                </div>
              </div>

              {/* Rating Badge */}
              <div className="absolute top-2 right-2 bg-background/80 backdrop-blur-sm rounded px-2 py-1 flex items-center space-x-1">
                <Icon name="Star" size={12} className="text-yellow-500 fill-current" />
                <span className="text-xs font-medium">{game.rating}</span>
              </div>
            </div>

            <div className="p-3">
              <h4 className="font-medium text-foreground text-sm mb-1 line-clamp-1">
                {game.title}
              </h4>
              <p className="text-xs text-muted-foreground mb-2">{game.gaming_studios?.name || 'Unknown Studio'}</p>

              <div className="flex items-center justify-between">
                <span className="text-xs text-primary bg-primary/10 px-2 py-1 rounded">
                  {game.game_category_mappings?.[0]?.game_categories?.name || 'Game'}
                </span>
                <span className="text-xs text-muted-foreground">
                  {game.estimated_play_time ? `${Math.floor(game.estimated_play_time / 60)}h ${game.estimated_play_time % 60}m` : 'Unknown'}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedGames;
